import type { Kit } from "~restock/orders/kit-builder/helpers/computeKits";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import ViewType from "~/@types/viewType";
import { fakeKits } from "~restock/orders/kit-builder/helpers/fakeData";

interface KittingState {
	addKitDialogOpen: boolean;
	draftKitName: string;
	editKitDialogOpen: boolean;
	kits: Kit[];
	selectedKitId: string | null;
	viewType: ViewType;
}

const initialState: KittingState = {
	addKitDialogOpen: false,
	draftKitName: "",
	editKitDialogOpen: false,
	kits: fakeKits,
	selectedKitId: null,
	viewType: "card"
};

const kittingSlice = createSlice({
	initialState,
	name: "restockKitting",
	reducers: {
		closeAddKitDialog: (state) => {
			state.addKitDialogOpen = false;
			state.draftKitName = "";
		},
		closeEditKitDialog: (state) => {
			state.editKitDialogOpen = false;
		},
		deleteKit: (state, action: PayloadAction<string>) => {
			state.kits = state.kits.filter((k) => k.id !== action.payload);
			if (state.selectedKitId === action.payload) state.selectedKitId = null;
		},
		openAddKitDialog: (state) => {
			state.addKitDialogOpen = true;
			state.draftKitName = "";
		},
		openEditKitDialog: (state) => {
			state.editKitDialogOpen = true;
		},
		setDraftKitName: (state, action: PayloadAction<string>) => {
			state.draftKitName = action.payload;
		},
		setSelectedKitId: (state, action: PayloadAction<string | null>) => {
			state.selectedKitId = action.payload;
		},
		setViewType: (state, action: PayloadAction<ViewType>) => {
			state.viewType = action.payload;
		},
		upsertKit: (state, action: PayloadAction<Kit>) => {
			const idx = state.kits.findIndex((k) => k.id === action.payload.id);
			if (idx === -1) state.kits.push(action.payload);
			else state.kits[idx] = action.payload;
		}
	}
});

export const {
	closeAddKitDialog,
	closeEditKitDialog,
	deleteKit,
	openAddKitDialog,
	openEditKitDialog,
	setDraftKitName,
	setSelectedKitId,
	setViewType,
	upsertKit
} = kittingSlice.actions;

export default kittingSlice.reducer;
